import React from 'react';
import styled from 'styled-components';
import { useOrders } from '../hooks/useOrders';
import { format } from 'date-fns';

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 20px;
`;

const Card = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
`;

const Title = styled.h2`
  margin: 0 0 12px 0;
  font-size: 20px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const Th = styled.th`
  text-align: left;
  font-weight: 600;
  padding: 10px 8px;
  border-bottom: 1px solid #e5e7eb;
`;

const Td = styled.td`
  padding: 10px 8px;
  border-bottom: 1px solid #f1f5f9;
`;

export default function MyOrders() {
  const { orders, loading, error } = useOrders();

  return (
    <Container>
      <Card>
        <Title>My Orders</Title>
        {loading && <p>Loading orders…</p>}
        {error && <p style={{color:'#ef4444'}}>Error: {String(error)}</p>}
        {!loading && orders.length === 0 && <p>No orders yet.</p>}
        {!loading && orders.length > 0 && (
          <Table>
            <thead>
              <tr>
                <Th>Date</Th>
                <Th>Order ID</Th>
                <Th>Status</Th>
                <Th>Payment</Th>
                <Th>Total</Th>
              </tr>
            </thead>
            <tbody>
              {orders.map(o => (
                <tr key={o.id}>
                  <Td>{o.created_at ? format(new Date(o.created_at), 'yyyy-MM-dd HH:mm') : '-'}</Td>
                  <Td>{o.id}</Td>
                  <Td>{o.status}</Td>
                  <Td>{o.payment_status}</Td>
                  <Td>{Number(o.grand_total).toFixed(2)} {o.currency}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Card>
    </Container>
  );
}


